import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { UserType } from "../views/auth/authApi";

type AuthState = {
  accessToken: string | null;
  tokenType: "Bearer" | null;
  expiresIn: string | null;
  userType: UserType | null;
};

const initialState: AuthState = {
  accessToken: null,
  tokenType: null,
  expiresIn: null,
  userType: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{
        accessToken: string;
        tokenType: "Bearer";
        expiresIn: string;
        userType: UserType;
      }>
    ) => {
      state.accessToken = action.payload.accessToken;
      state.tokenType = action.payload.tokenType;
      state.expiresIn = action.payload.expiresIn;
      state.userType = action.payload.userType;
    },
    clearAuth: (state) => {
      state.accessToken = null;
      state.tokenType = null;
      state.expiresIn = null;
      state.userType = null;
    },
  },
});

export const { setCredentials, clearAuth } = authSlice.actions;
export default authSlice.reducer;
